import React, { memo } from 'react';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';
import HBMoneyInput, { HBMoneyInputProps } from '../HBMoneyInput/HBMoneyInput';
import { HBMoneySizes } from '../HBMoneyInput/HBMoneyInput.utils';

export interface HBMoneyInputFieldProps
    extends HBBaseFormFieldProps,
        Omit<HBMoneyInputProps, 'size'> {
    /** HTML `id` for the field; forwarded to the input and used as the `<label htmlFor>` target. */
    id: string;
    /** Input size; controls font size and padding. Defaults to `'sm'`. */
    size?: HBMoneySizes;
}

const HBMoneyInputField = ({
    size = 'sm',
    ...props
}: HBMoneyInputFieldProps) => {
    const { fieldProps, inputProps } = splitFieldProps(props);

    return (
        <HBBaseFormField {...fieldProps} size={size}>
            <HBMoneyInput {...inputProps} size={size} />
        </HBBaseFormField>
    );
};

export default memo(HBMoneyInputField);
